__turbopack_context__.v({
  "active": "GlucoseResponse-module__r8H79W__active",
  "content": "GlucoseResponse-module__r8H79W__content",
  "foodItemCard": "GlucoseResponse-module__r8H79W__foodItemCard",
  "foodItems": "GlucoseResponse-module__r8H79W__foodItems",
  "foodZones": "GlucoseResponse-module__r8H79W__foodZones",
  "mobileFoodZones": "GlucoseResponse-module__r8H79W__mobileFoodZones",
  "parentContainer": "GlucoseResponse-module__r8H79W__parentContainer",
  "root": "GlucoseResponse-module__r8H79W__root",
  "tab": "GlucoseResponse-module__r8H79W__tab",
  "tabs": "GlucoseResponse-module__r8H79W__tabs",
  "tag": "GlucoseResponse-module__r8H79W__tag",
  "zone": "GlucoseResponse-module__r8H79W__zone",
});
